/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import ClientAuth from "../components/booking/ClientAuth";
import NavigationHeader from "../components/NavigationHeader";
import Container from "../components/Container";
import Text from "../components/ui/Text";

const LoginText = styled((props) => <Text {...props} />)`
  && {
    padding: 16px 0;
  }
`;

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const initialTab = location.state?.tab;


  const handleAuthSuccess = () => {
    navigate(-1);
  };

  return (
    <Container>
      <NavigationHeader to={-1} title="Login" navigation cart />
      <LoginText color="dark">Please Sign up / Sign in to continue</LoginText>
      <ClientAuth onAuthSuccess={handleAuthSuccess} initialTab={initialTab} />

    </Container>
  );
};

export default Login;
